import React from 'react';
import {
  Typography,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Button
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { useSuperDuper } from '../context/SuperDuperContext';
import { renderLoading, renderError } from '../components/StatusViews';
import { generateReceiptPDF } from '../utils/receiptPdf';

const ReceiptsTab = () => {
  const {
    receipts,
    receiptsLoading,
    receiptsError,
    receiptsPage,
    receiptsRowsPerPage,
    handleReceiptsChangePage,
    handleReceiptsChangeRowsPerPage
  } = useSuperDuper();

  return (
    <>
      <Box sx={{ mt: { xs: 1, sm: 2, md: 4 } }}>
        <Typography
          variant="h4"
          sx={{ mb: { xs: 2, sm: 4 }, fontSize: { xs: '1.35rem', sm: '2.125rem' } }}
        >
          Payment Receipts
        </Typography>
        
        <Box sx={{ mb: { xs: 2, sm: 4 } }}>
          <Paper sx={{ p: { xs: 2, sm: 3 } }}>
            <Typography variant="h6" gutterBottom>
              Summary
            </Typography>
            <Box sx={{ display: 'flex', gap: { xs: 2, sm: 4 }, flexWrap: 'wrap' }}>
              <Box>
                <Typography variant="subtitle2" color="text.secondary">
                  Total Receipts
                </Typography>
                <Typography variant="h4" sx={{ fontSize: { xs: '1.5rem', sm: '2.125rem' } }}>
                  {receipts.length}
                </Typography>
              </Box>
              <Box>
                <Typography variant="subtitle2" color="text.secondary">
                  Total Revenue
                </Typography>
                <Typography variant="h4" sx={{ fontSize: { xs: '1.5rem', sm: '2.125rem' } }}>
                  ₹{receipts.reduce((sum, receipt) => sum + (receipt.amount || 0), 0).toFixed(2)}
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Box>

        {receiptsLoading ? (
          renderLoading()
        ) : receiptsError ? (
          renderError(receiptsError)
        ) : (
          <>
            <TableContainer component={Paper} sx={{ maxWidth: '100%', overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
              <Table sx={{ minWidth: 650 }} aria-label="receipts table">
                <TableHead>
                  <TableRow>
                    <TableCell>Customer Name</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Phone</TableCell>
                    <TableCell>Plan</TableCell>
                    <TableCell>Amount</TableCell>
                    <TableCell>GST Amount</TableCell>
                    <TableCell>Receipt Date</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {receipts
                    .slice(receiptsPage * receiptsRowsPerPage, receiptsPage * receiptsRowsPerPage + receiptsRowsPerPage)
                    .map((receipt) => (
                      <TableRow key={receipt._id}>
                        <TableCell>{receipt.customerName}</TableCell>
                        <TableCell>{receipt.customerEmail}</TableCell>
                        <TableCell>{receipt.customerPhone}</TableCell>
                        <TableCell>{receipt.planName}</TableCell>
                        <TableCell>₹{(receipt.amount || 0).toFixed(2)}</TableCell>
                        <TableCell>₹{(receipt.gstAmount || 0).toFixed(2)}</TableCell>
                        <TableCell>
                          {new Date(receipt.receiptDate).toLocaleString()}
                        </TableCell>
                        <TableCell>
                          <Button
                            variant="outlined"
                            size="small"
                            startIcon={<DownloadIcon />}
                            onClick={() => generateReceiptPDF(receipt)}
                            sx={{ minWidth: 'auto' }}
                          >
                            PDF
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={receipts.length}
              rowsPerPage={receiptsRowsPerPage}
              page={receiptsPage}
              onPageChange={handleReceiptsChangePage}
              onRowsPerPageChange={handleReceiptsChangeRowsPerPage}
              sx={{
                '.MuiTablePagination-toolbar': {
                  flexWrap: 'wrap',
                  justifyContent: { xs: 'center', sm: 'flex-end' },
                  px: { xs: 0, sm: 2 }
                }
              }}
            />
          </>
        )}
      </Box>
    </>
  );
};

export default ReceiptsTab;
